import type {Step} from "../../components/stepper/Step.ts";
import {useAtomValue} from "jotai";
import {ApiAtom} from "../../common-process/1-metl-connection/MetlConnectionProperties.ts";
import {OptionSelectionWidget} from "./OptionSelectionWidget.tsx";

export function useAnalysisOptionsStep(): Step {
    const connection = useAtomValue(ApiAtom)
    return {
        name: "Analysis Options",
        isAvailable: connection !== undefined,
        isCompleted: true,
        Widget: OptionSelectionWidget
    }
}